import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoaderComponent implements OnInit {

  @Input() type: string = 'normal'
  @Input() text: string = 'Loading...'
  @Input() ShowLoader: Boolean = false
  @Input() CStyle: any
  constructor() { }

  ngOnInit() {
  }

}
